import * as styles from '../../PublishPaymentStatus.css';
import * as React from 'react';
import { IconBlock16 } from '@cian/ui-kit';

interface IProps {
  content: React.ReactNode;
}

export const PaymentStatusCanceled = (props: IProps) => {
  const { content } = props;

  return (
    <>
      <IconBlock16 color="error_100" data-mark="icon|fail" />

      <div className={styles['text']}>{content}</div>
    </>
  );
};
